import { createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../../../api';
import { createBrowserHistory } from 'history';
import { setTokenRef, getToken, removeToken, setToken, removeTokenRef, removeUser, setUser } from '../helper/token';
import jwt_decode from 'jwt-decode';
import { toastSuccess, toastAlert, toastError } from '@pages/components-overview/toasts';

const navigate = createBrowserHistory();

const removeData = () => {
    removeToken();
    removeTokenRef();
    removeUser();
};

export const fetchUserData = createAsyncThunk('auth/fetchUserData', async () => {
    const res = await api.post('/user');
    setUser(JSON.stringify(res.data));
    return res.data;
});

export const loginGoogle = createAsyncThunk('auth/loginGoogle', async (payload) => {
    try {
        const res = await api.post('/google/sign-in', payload);
        if (res.status === 200) {
            setToken(res.data.access_token);
            setTokenRef(res.data.refresh_token);
            setUser(JSON.stringify(jwt_decode(res.data.access_token)));
            toastSuccess('Successfully logged in');
            navigate.push('/dash');
        } else {
            toastError('Undefined error');
            removeData();
        }
        return res.data;
    } catch (e) {
        toastError(e?.response?.data?.message);
        removeData();
        throw e?.response?.data;
    }
});

export const login = createAsyncThunk('auth/login', async (payload) => {
    try {
        const res = await api.post('/sign-in', payload);
        if (res.status === 200) {
            setToken(res?.data?.access_token);
            setTokenRef(res?.data?.refresh_token);
            setUser(JSON.stringify(jwt_decode(res?.data?.access_token)));
            toastSuccess('Successfully logged in');
            navigate.push('/dash');
        } else {
            toastError('Undefined error');
            removeData();
        }
        return res.data;
    } catch (e) {
        toastError(e?.response?.data?.message);
        removeData();
        throw e?.response?.data;
    }
});

export const signOut = createAsyncThunk('auth/signOut', async () => {
    try {
        const res = await api.put('/sign-out');
        if (res.status === 200) {
            removeData();
            toastAlert('Successfully logged out');
        } else {
            toastError('Undefined error');
            removeData();
        }
        return res.data;
    } catch (e) {
        toastError(e?.response?.data?.message);
        removeData();
        throw e?.response?.data;
    }
});
